module.exports = __webpack_public_path__ + "img/thaiho.34d4f20c.png";